import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

import { Pagenation } from '../../../_component/pagenation';

export function AdminNotice(routeProps: RouteComponentProps) {
  const [items, setItems] = useState<any[]>([]);
  const [
    pageInfo = { total: 10, rowCount: 10, page: 1, totalPages: 1 },
    setPageInfo,
  ] = useState<any>();
  const [searchSelect, setSearchSelect] = useState<string>('all');
  const [searchText, setSearchText] = useState<string>('');
  const dispatch = useDispatch();
  const history = useHistory();
  const category = 'notice';

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getBoardList();
  }, []);

  const options = [
    {
      value: 'all',
      name: '전체',
    },
    {
      value: 'subject',
      name: '제목',
    },
    {
      value: 'content',
      name: '내용',
    },
    {
      value: 'writer',
      name: '작성자',
    },
  ];

  // 페이지가 랜더링 되고 데이터 가져오는 부분
  const getBoardList = async () => {
    if (searchText.length === 0) {
      await server
        .getBoardList(category, pageInfo.page, pageInfo.rowCount)
        .then((payload) => {
          setItems(payload.items);
          // setMeta(payload.meta);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          console.log('error :', error);
        });
      // setAdd(routeProps.location.state);
    } else {
      // 검색창에 단어가 있을 때
      switch (searchSelect) {
        case 'subject':
          await server
            .searchBoardList(category, 1, pageInfo.rowCount, searchText, '', '', '')
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'writer':
          await server
            .searchBoardList(category, 1, pageInfo.rowCount, '', searchText, '', '')
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'content':
          await server
            .searchBoardList(category, 1, pageInfo.rowCount, '', '', searchText, '')
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'all':
          await server
            .searchBoardList(category, 1, pageInfo.rowCount, '', '', '', searchText)
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        default:
          break;
      }
    }
  };

  // 아이템 pager 클릭 시
  const onClickPage = async (pageParam: any) => {
    // setCurrentPage(pageParam);
    if (searchText.length !== 0) {
      switch (searchSelect) {
        case 'subject':
          await server
            .searchBoardList(category, pageParam.page, pageParam.rowCount, searchText, '', '', '')
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'writer':
          await server
            .searchBoardList(category, pageParam.page, pageParam.rowCount, '', searchText, '', '')
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'content':
          await server
            .searchBoardList(category, pageParam.page, pageParam.rowCount, '', '', searchText, '')
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'all':
          await server
            .searchBoardList(category, pageParam.page, pageParam.rowCount, '', '', '', searchText)
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        default:
          break;
      }
    } else {
      await server
        .getBoardList(category, pageParam.page, pageParam.rowCount)
        .then((payload) => {
          setItems(payload.items);
          // setMeta(payload.meta);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          console.log('error :', error);
        });
    }
  };

  const onClickItem = (item: any) => {
    routeProps.history.push({
      pathname: `/admin/board/adminBoardView/${category}/${item.id}`,
    });
  };

  const onClickReply = (id: any) => {
    routeProps.history.push({
      pathname: `/admin/board/adminReplyView/${category}/${id}`,
    });
  };

  const listRow = () => {
    return (
      <div className="table">
        <ul className="row title">
          <li className="counter">번호</li>
          <li className="book-title">제목</li>
          <li className="writer">작성자</li>
          <li className="date">작성일</li>
          <li className="views">조회수</li>
        </ul>
        {items.map((item: any) => (
          <div key={item.id}>
            <ul
              className="row"
              key={item.id}
              onClick={() => {
                onClickItem(item);
              }}
            >
              <li className="counter">{item.id}</li>
              <li className="book-title">{item.subject}</li>
              <li className="writer">{item.writer?.name}</li>
              <li className="date">{new Date(item.modDate).toLocaleDateString()}</li>
              <li className="views">{item.hit}</li>
            </ul>
            {getReply(item.replies)}
          </div>
        ))}
      </div>
    );
  };

  const getReply = (replyList: []) => {
    const ret = [];
    for (let i = 0; i < replyList.length; i++) {
      const data: any = replyList[i];
      ret.push(
        <ul
          className="row"
          key={data.id}
          onClick={() => {
            const id = Number(data.id);
            onClickReply(id);
          }}
        >
          <li className="counter">{data.id}</li>
          <li className="book-title"> re: {data.subject}</li>
          <li className="writer">{data.writer?.name || '구민사'}</li>
          <li className="date">{new Date(data.modDate).toLocaleDateString()}</li>
          <li className="views">{data.hit || '-'}</li>
        </ul>
      );
    }
    return <>{ret}</>;
  };

  return (
    <main className="list wrapper">
      <div className="title">
        <h1>공지사항</h1>
        <div className="buttons">
          <button
            type="button"
            onClick={() => {
              routeProps.history.push({
                pathname: `/admin/board/adminBoardWrite/${category}/0`,
              });
            }}
          >
            글쓰기
          </button>
        </div>
      </div>
      {/* ↑ 여기 냅두기 */}
      <div className="content">
        <div className="table-header">
          <div className="search">
            <div className="selectbox">
              <select
                name=""
                id=""
                onChange={(event) => {
                  setSearchSelect(event.target.value);
                }}
              >
                {options.map((it) => (
                  <option value={it.value} key={it.value}>
                    {it.name}
                  </option>
                ))}
              </select>
            </div>
            <input
              type="search"
              onChange={(event) => {
                setSearchText(event.target.value);
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  getBoardList();
                }
              }}
            />
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </div>
        </div>
        {/* ↑ 검색창 */}
        {listRow()}
        {/* ↑ 여기 data 뿌리기 */}
        {/* {GetTableFooter(
          meta?.currentPage,
          meta?.totalPages,
          (page: number) => onClickPage(page),
          '',
          onClickDelete,
          false
        )} */}
        {pageInfo ? (
          <Pagenation PageInfo={pageInfo} PagenationHandler={onClickPage} IsFirstEndArrow />
        ) : (
          ''
        )}
        {/* ↑ 여기 페이징 */}
      </div>
    </main>
  );
}
